import { ContestDetail } from '@bpm-web-app/components/pages';

const ContestPage = () => <ContestDetail />;

export default ContestPage;
